var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container column" },
    [
      _c(
        "el-card",
        { staticClass: "card", attrs: { id: "detalhesOs__main-container" } },
        [
          _vm.isTabelaOS
            ? _c(
                "div",
                {
                  key: "tabela",
                  attrs: { id: "detalhesOs__tabela-container" }
                },
                [
                  _c("TabelaDetalheOS", {
                    attrs: { dados: _vm.dadosOS, id: "detalhesOs__tabela" }
                  })
                ],
                1
              )
            : _vm._e(),
          !_vm.isTabelaOS
            ? _c(
                "div",
                {
                  key: "grafico",
                  staticClass: "bgWhite",
                  attrs: { id: "detalhesOs__grafico-container" }
                },
                [
                  _c("GraficoDetalheOS", {
                    attrs: { dados: _vm.dadosOS, id: "detalhesOs__grafico" }
                  })
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _c(
        "div",
        { attrs: { id: "detalhesOs__radio-btn-container" } },
        [
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.isTabelaOS,
                callback: function($$v) {
                  _vm.isTabelaOS = $$v
                },
                expression: "isTabelaOS"
              }
            },
            [
              _c("el-radio-button", { attrs: { label: false } }, [
                _vm._v("Gráfico")
              ]),
              _c("el-radio-button", { attrs: { label: true } }, [
                _vm._v("Tabela")
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { id: "detalhesOs__btn-acao-container" } },
        [
          _c(
            "el-button",
            {
              attrs: { type: "default", id: "detalhesOs__voltar-btn" },
              on: { click: _vm.voltar }
            },
            [_c("span", [_vm._v("Voltar")])]
          ),
          _c(
            "el-button",
            {
              staticClass: "primary",
              attrs: { type: "primary", id: "detalhesOs__exportar-btn" },
              on: {
                click: function($event) {
                  return _vm.exportarTabelaDetalhes(_vm.isTabelaOS)
                }
              }
            },
            [
              _c("i", { staticClass: "fal fa-file-csv" }),
              _c("span", [_vm._v("  Exportar")])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f7cc3b92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7cc3b92","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/relatorios/os/DetalhesOS.vue
// module id = null
// module chunks = 